<style type="text/css" media="screen">
.pre-image{
	height: 142px;
	/*width: 142px;*/
	border-radius: 10px;
}
</style>

<template>
	<div class="pt-4">
		<v-form ref="add_line_form"  lazy-validation >
			<v-row justify="start" class="custome-form">
				<v-col cols="6" md="4">
					<v-row  >
						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.LINE_ID}}</label>
							<v-text-field
							:placeholder="$lang.LINE_ID"
							v-model="form.line_id"
							single-line
							outlined
							dense
							maxlength="5"
							:rules="$rules.LINE_ID"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.LINE_NAME}}</label>
							<v-text-field
							:placeholder="$lang.LINE_NAME"
							v-model="form.line_name"
							single-line
							outlined
							dense
							maxlength="100"
							:rules="$rules.LINE_NAME"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.AREA}}</label>
							<v-text-field
							:placeholder="$lang.AREA"
							v-model="form.area"
							single-line
							outlined
							dense
							maxlength="100"
							:rules="$rules.AREA"
							></v-text-field>
						</v-col>
						<!-- <v-col cols="10" md="12" class="py-0 px-2">
							<label>{{$lang.LINE_DELIVERY_TIME}}</label>
							<v-text-field
							:placeholder="$lang.LINE_DELIVERY_TIME"
							v-model="form.line_delivery_time"
							single-line
							outlined
							dense
							maxlength="10"
							:rules="$rules.DELIVERY_TIME"
							></v-text-field>
						</v-col> -->
						<v-col cols="10" md="11" class="py-0 px-2">
							<v-btn color="primary" class="signup-btn-style mt-12 px-6" @click="addLine()" :loading="btn_loading">
								<b>Continue</b>
							</v-btn>
						</v-col>

					</v-row>
				</v-col>
			</v-row>
		</v-form>

	</div>
</template>
<script type="text/javascript">

export default{
	components:{
	},
	data(){
		return{
			is_edit:false,
			line_id:"",// djnago id 
			form:{
				line_id:"",// unique id for line 
				line_name:"",
				area:"",
				line_delivery_time:"",
			},
			btn_loading:false,
		}
	},
	created(){
		if(this.$route.name=="edit-line")	{
			this.is_edit=true
			this.line_id= this.decrypt(this.$route.params.line_id)
			this.getlineDetails()
		}
	},
	methods:{
		
		/*  Add Edit Retailer  */ 	
		addLine(){
			const self=this
			if (this.$refs.add_line_form.validate()==false)
				return false

			self.btn_loading=true
			console.log(self.form)
			var	form = new FormData();


			form.append("id",self.line_id)
			form.append("line_id",self.form.line_id)
			form.append("line_name",self.form.line_name)
			form.append("area",self.form.area)
			form.append("line_delivery_time",self.form.line_delivery_time)


			let url=this.$urls.CREATE_LINE
			if(self.is_edit){
				url=this.$urls.EDIT_LINE
				form.append("id",self.line_id)
			}

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					self.$router.push({name:'manage-line'})

				}
			};
			const finallyHandler = () => {
				self.btn_loading=false
			};

			this.request_POST(self,url,form,successHandler,null,null,finallyHandler)

		},
		/* fetch retailer details  for the  edit data */ 
		getlineDetails(){
			const self=this
			let params={
				line_id:self.line_id
			};
			self.table_loading=true

			const successHandler = (response) => {
				if (response.data.success){
					this.form=response.data.data
				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.LINE_DETAILS,params,successHandler,null,null,finallyHandler)
		},
	}

}

</script>